<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-edit_mechanical_product'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t("edit_mechanical_product_settings") }}</template>

    <template slot="body">
      <div class="body-container">
        <div style="display: flex;width: 100%;gap: 2rem;">
          <TextField
          :id="'sequence'"
          class="m1"
          :disabled="true"
          style="width: 100%;"
          v-bind="textFieldConfig"
          v-model="product.track_count"
          :placeholder="$t('track_count')"
          @valuechanged="onTextFieldValueChange"
         
        />
        <TextField
          :id="'cap'"
          class="m1"
           style="width: 100%;"
          v-bind="textFieldConfig"
          v-model="product.cap"
          :placeholder="$t('CAP')"
          @valuechanged="onTextFieldValueChange"
        
        />
        </div>
        <div style="display: flex;width: 100%;gap: 2rem;">
          <Dropdown
          :id="'mechanical_rate_id_product'"
          class="m2"
           style="width: 100%;"
          :options="mechanical_ratesTV"
          deselect
          :selected="
            mechanical_ratesTV.find(
              (e) => e.value == product.mechanical_rate_id_product
            )
          "
          :placeholder="$t('mechanical_rate')"
          box
          @selectedChange="(e) => onDropdownChange('mechanical_rate_id_product', e)"
        ></Dropdown>
        <TextField
          :id="'percentage'"
          class="m1"
          :type="product.percentage"
           style="width: 100%;"
          v-bind="textFieldConfig"
          :value="product.percentage"
          :placeholder="$t('percentage')"
          @valuechanged="onTextFieldValueChange"
        
        />
        </div>
        <div style="display: flex;width: 100%;gap: 2rem;">
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'extra_minutes'"
                :id="'extra_minutes'"
                :checked="product.extra_minutes == 1"
                 @click="e => onTextCheckboxChange(e, 'extra_minutes')"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("extra_minutes") }}</div>
          </div>
        <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                 @click="e => onTextCheckboxChange(e, 'deduct_coversongs')"
                type="checkbox"
                :name="'deduct_coversongs'"
                :id="'deduct_coversongs'"
                :checked="product.deduct_coversongs == 1"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("deduct_coversiongs") }}</div>
          </div>
        </div>
        <div  v-if="product.deduct_coversongs==1" style="display: flex;width: 100%;gap: 2rem;padding-bottom: 10px">
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                   @click="e => onTextCheckboxChange(e, 'allow_negative')"
                type="checkbox"
                :name="'allow_negative'"
                :id="'allow_negative'"
                :checked="product.allow_negative == 1"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("allow_negative") }}</div>
          </div>
  
        </div>
        <SearchList
          v-if="product.deduct_coversongs==1"
          style="padding-bottom: 10px"
          :id="'product_track_id'"
          :items="items"
          :keyProperty="'product_track_id'"
          :label="'artist'"
          :placeholder="'Search products'"
          :selectionNumber="'radio'"
          :isSearchable="false"
          :selected="selectedProducts"
          @selected="onProductsSelected"
          :headers="[
          {
            text: $t('set'),
            value: 'set',
          },
          {
            text: $t('seq'),
            value: 'seq',
          },
          {
            text: $t('artist'),
            value: 'artist',
          },
          {
            text: $t('title'),
            value: 'title',
          },
          {
            text: $t('playtime'),
            value: 'playtime',
          },
        ]"
        >
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row"
              
            >
              <dt
                class="dt-table2--column"
                style="border-right:1px solid #fefefe"
              >
                <div class="ut-flex">
                  <div style="flex:0.2" class="checkbox-container">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        :name="item.product_track_id"
                        :id="item.product_track_id"
                        :checked="selectedProducts.has(item.product_track_id)"
                        @click="e => onCheckboxChange(e, 'product_track_id', item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div style="flex:0.8;padding-left: 5px;" class="txtov">
                    {{ item.set_no }}
                  </div>
                </div>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.seq_no }}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.artist }}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.title }}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.playtime }}</span>
              </dt>
            </tr>
          </template>
        </SearchList>
        <Dropdown
          :id="'mechanical_rate_id_coversongs'"
          class="m2"
           v-if="product.deduct_coversongs==1"
          :options="mechanical_rates_coversongsTV"
          deselect
          :selected="
            mechanical_rates_coversongsTV.find(
              (e) => e.value == product.mechanical_rate_id_coversongs
            )
          "
          :placeholder="$t('mechanical_rate_coversongs')"
          box
          @selectedChange="(e) => onDropdownChange('mechanical_rate_id_coversongs', e)"
        ></Dropdown>
        <div  v-if="product.deduct_coversongs==1" class="dt-checkbox-control">
          
            <div class="dt-checkbox v2">
              <input
                  @click="e => onTextCheckboxChange(e, 'extra_minutes_coversongs')"
                type="checkbox"
                :name="'.extra_minutes_coversongs'"
                :id="'.extra_minutes_coversongs'"
                :checked="product.extra_minutes_coversongs == 1"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $dft.snakeCaseToWords($t("extra_minutes_coversongs")) }}</div>
          </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { Subject } from "rxjs";
import { ContractsService } from "../../services/contracts.service";
import { addRemoveSet } from "../../../../utility";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      unrelatedProducts: [],
      searchString: "",
      productSearchString: "",
      searchSubject: new Subject(),
      selectedProducts: new Set(),
      formData:null,
      product:{ cap: '',	
  mechanical_rate_id_product: '',	
  percentage: '100',	
  extra_minutes: '',	
  deduct_coversongs:'',	
  allow_negative: '',	
  cover_product_track_ids:[],	
  mechanical_rate_id_coversongs: '',	
  extra_minutes_coversongs:'',	},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: false,
    },
    };
  },
  mounted: async function() {
    const res = await ContractsService.mechContractEditProductFormData(this.contract_pos_id);
     this.formData=res.data;
     this.product={
      ...this.product,
      ...this.formData.contract_pos.json_data
     }
     if(this.product.cover_product_track_ids){
      this.product.cover_product_track_ids=this.product.cover_product_track_ids.map(id=>{
      return parseInt(id)
     });
      
     this.selectedProducts=new Set(this.product?.cover_product_track_ids||[])
     console.log('this.selectedProducts',this.selectedProducts)
     }
    
  },
  computed: {
   
    selectedProductsFN: function() {
      return  this.selectedProducts;
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    },
    contract_pos_id: function() {
      return this.$route.query.contract_pos_id;
    },
    mechanical_ratesTV: function () {
      return createTV(this.formData?.mechanical_rates, "rate_name", "mechanical_rate_id");
    },
    mechanical_rates_coversongsTV: function () {
      return createTV(this.formData?.mechanical_rates_coversongs, "rate_name", "mechanical_rate_id");
    },
    items: function() {
      return this.formData?.tracks || [];
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onOkClick: async function() {
      const product_ids = Array.from(this.selectedProducts).join(","); // Convert to Array,  Join -- convert to string
      const data={
value:JSON.stringify({
  track_count: this.product.track_count,	
  cap: this.product.cap,	
  mechanical_rate_id_product: this.product.mechanical_rate_id_product,	
  percentage: this.product.percentage,	
  extra_minutes: this.product.extra_minutes,	
  deduct_coversongs:this.product.deduct_coversongs,	
  allow_negative: this.product.allow_negative,	
  cover_product_track_ids:product_ids.split(','),	
  mechanical_rate_id_coversongs: this.product.mechanical_rate_id_coversongs,	
  extra_minutes_coversongs:this.product.extra_minutes_coversongs,	
}),
name:'json_data',
kVal: this.contract_pos_id,
key:this.contract_pos_id,
json_op:'new',
  table : 'l_contract_pos',
  modify_type : 'json',


      }
      const res=await ContractsService.modifyJSON({...data})
      let res1 = await ContractsService.fetchDetailsTabContractsItem(this.contract_id);
      this.$emit("added", res1.data);
    },
    onSearchInputKeyup: function(e) {
      this.productSearchString = e.target.value;
      this.searchSubject.next(this.productSearchString);
    },
    onDropdownChange(name, value) {
      console.log({ name, value });
      this.product[name] = value.value;
      console.log('this.product',this.product)
    },
    onTextFieldValueChange(name,value){
      console.log({ name, value });
      this.product[name] = value;
      console.log('this.product',this.product)
    },
    onCheckboxChange: function(event, name, item) {
      console.log({event, name, item})
      const value = event.target.checked;
      this.selectedProducts = addRemoveSet(
        event.target.checked,
        this.selectedProducts,
        item.product_track_id
      );
      console.log("WWWW",this.selectedProducts);
    },

    onProductsSearched: async function(searchString) {
      this.productSearchString = searchString;
      const res = await ContractsService.searchUnrelatedProducts({
        contract_id: this.contract_id,
        search: searchString
      });
      this.unrelatedProducts = res.data.products;
    },

    onProductsSelected: function(selected) {
      console.log('selected',selected)
      this.selectedProducts = selected;
    },
    onTextCheckboxChange: function (event, name) {
      const checked = event.target.checked;
      this.product[name] = checked?1:0;
     

    },
    onProductSelected: function(item){
      this.selectedProducts = addRemoveSet(
        !this.selectedProducts.has(item.product_track_id),
        this.selectedProducts,
        item.product_track_id
      );
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-edit_mechanical_product {
  .dt-table2--body{
    height: 200px !important;
    max-height: fit-content!important;
    min-height: fit-content!important;
  }
  .yello{
  background-color: yellow !important
}
  .dt-checkbox-control {
    align-items: center;
    height: 32px;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }
  .ut-flex {
    .checkbox-container {
      flex: 0.1 !important;
    }

    .txtov {
      flex: 0.9 !important;
    }
  }
}
</style>
